module.exports = __webpack_public_path__ + "img/wave.43c923a8.png";